export default __webpack_public_path__ + "static/media/lk.1ffbc386.svg";